import React from 'react';

type BadgeVariant = 'default' | 'success' | 'warning' | 'danger' | 'info';

interface BadgeProps {
    children: React.ReactNode;
    variant?: BadgeVariant;
    /** Adds a pulsing dot before the label */
    dot?: boolean;
    className?: string;
}

const variants: Record<BadgeVariant, string> = {
    default: 'bg-zinc-500/10 text-zinc-400 border-zinc-500/20',
    success: 'bg-emerald-500/10 text-emerald-400 border-emerald-500/20',
    warning: 'bg-amber-500/10 text-amber-400 border-amber-500/20',
    danger: 'bg-rose-500/10 text-rose-400 border-rose-500/20',
    info: 'bg-cyan-500/10 text-cyan-400 border-cyan-500/20',
};

const dotColors: Record<BadgeVariant, string> = {
    default: 'bg-zinc-400',
    success: 'bg-emerald-400',
    warning: 'bg-amber-400',
    danger: 'bg-rose-400',
    info: 'bg-cyan-400',
};

export function Badge({ children, variant = 'default', dot = false, className = '' }: BadgeProps) {
    return (
        <span
            className={`
        inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md
        text-[11px] font-semibold uppercase tracking-wider
        border
        ${variants[variant]}
        ${className}
      `}
        >
            {dot && (
                <span className={`w-1.5 h-1.5 rounded-full ${dotColors[variant]} ${variant === 'danger' ? 'animate-pulse' : ''}`} />
            )}
            {children}
        </span>
    );
}
